module.exports = __webpack_public_path__ + "img/lateral-therapy.9865d993.jpg";